<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="userData.account"
          :label="$t('profile.sections.common.name')"
          readonly
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          v-model="userData.sub_type"
          :items="$t('profile.subscriptions')"
          :label="$t('profile.sections.account.sub')"
          readonly
          dense
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="userData.sub_date"
          :label="$t('profile.sections.account.date-sub')"
          readonly
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        offset="6"
        cols="6"
      >
        <v-text-field
          v-model="userData.sub_renewal"
          :label="$t('profile.sections.account.date-renewal')"
          :disabled="userData.sub_type == '2'"
          readonly
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="userData.licenses"
          :label="$t('profile.sections.account.sub-license')"
          readonly
          dense
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="userData.users"
          :label="$t('profile.users')"
          readonly
          dense
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import { ProfileAccountConnector } from "../Database/ProfileAccountConnector.js";

export default {
  data() {
    return {
      accountConnector: new ProfileAccountConnector(this.$store.state.user),
      userData: {},
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getAccountInfos();
    }
  },
  methods: {
    getAccountInfos() {
      this.accountConnector
        .getAccountInfos()
        .then((userInfos) => {
          this.userData = {
            account: userInfos.name,
            sub_type: userInfos.sub_type,
            sub_date: userInfos.sub_date,
            sub_renewal: userInfos.sub_renewal,
            licenses: userInfos.nb_lic,
            users: userInfos.nb_usr,
          };
        })
        .catch((err) => {
          console.error("Error on getting accountData : " + err);
        });
    },
  },
};
</script>

<style></style>
